export const PROCESS_MESSAGES = 'app/PROCESS_MESSAGES';
export const RESET_STORE = 'app/RESET_STORE';
